document.addEventListener('DOMContentLoaded', function() {
  const utmKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id'
  ];

  // Internal product links must not start a new acquisition campaign.
  document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin) return;

      utmKeys.forEach(function(key) {
        url.searchParams.delete(key);
      });

      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (error) {
      console.warn('Attribution cleanup: invalid product URL', link);
    }
  });

  // Measure blog-to-product clicks without corrupting source/medium attribution.
  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href*="/products/"]');
    if (!link) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'blog_product_click',
      link_url: link.href,
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim()
    });
  });

  document.querySelectorAll('a[href*="thefloraladvisor.com"]').forEach(function(link) {
    var text = link.textContent;
    link.parentNode.replaceChild(document.createTextNode(text), link);
  });

  (function walk(node) {
    node.childNodes.forEach(function(child) {
      if (child.nodeType === Node.TEXT_NODE) {
        child.textContent = child.textContent.replace(/FloralAdvisor/g, 'FlowerAdvisor');
      } else {
        walk(child);
      }
    });
  })(document.querySelector('article') || document.body);
});
